import type { State } from './typings'
import { clearedFilters } from '../constants'
import { ActivityStatus } from '../../constants'
import { ActivitySummaryHelpers } from '../helpers'
import type { IUser } from '@user/store/authorization'
import type { IUserPreferenceFilter } from '@user/store/userPreferences'
import { ActivitySummaryDTO, ActivitySummaryFilterSet } from '../typings'
import { deserializeFilters, normalizeFilters } from '@user/components/Filters'

type InitArg = {
  currentUser: IUser
  savedFilters?: IUserPreferenceFilter
}

export function init(params: InitArg): State {
  const { currentUser, savedFilters } = params

  const defaultFilters = ActivitySummaryHelpers.getDefaultFilters(currentUser)

  const loadedFilters = !!savedFilters
    ? deserializeFilters<ActivitySummaryDTO, ActivitySummaryFilterSet>(
        clearedFilters,
        savedFilters.filter,
      )
    : defaultFilters

  const filterSet = normalizeFilters<
    ActivitySummaryDTO,
    ActivitySummaryFilterSet
  >(loadedFilters)

  return {
    anchorEl: null,
    editActivityId: undefined,
    editStatusActivityId: 0,
    filterSet,
    open: false,
    defaultFilters,
    activeTab: ActivityStatus.Todo,
    filterCacheId: savedFilters?.id,
    statsState: {
      loading: false,
      data: undefined,
    },
    tableState: {
      paginationState: { page: 0, pageSize: 50 },
      rows: [],
      totalRows: 0,
      loading: false,
    },
  }
}
